"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LetsStartWithARealConversation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="227846" id="call-to-action" className="bg-background text-foreground py-24 lg:py-32 border-t border-border">
            <div className="container mx-auto px-4 md:px-6">
                <div ref={ref} className={`grid md:grid-cols-2 gap-10 md:gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                    <div className="max-w-2xl">
                        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground font-default leading-tight">
                            Schedule your Miami property inspection today.
                        </h2>
                    </div>
                    <div className="flex md:justify-end">
                        <Button asChild size="lg" className="rounded-lg bg-primary hover:bg-primary/90 text-primary-foreground text-xl px-10 py-8 h-auto font-semibold transition-transform hover:scale-105 shadow-lg">
                            <Link to="https://trusted-fl.com/#schedule-your-inspection">
                                Book Your Inspection
                            </Link>
                        </Button>
                    </div>
                </div>
            </div>
        </section>;
}